import { Box, FormLabel, Grid, Typography } from '@mui/material'
import { toastHelper } from '../../../util/toastHelper'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import Style from '../../molecules/VenderModal/VendorModal.module.scss'
import Stepper from '../../atoms/Stepper/Stepper'
import TextArea from '../../atoms/textarea/TextArea'
import { useSelector } from 'react-redux'
import { BUSINESS_PROFILE_TOTAL_STEPS } from '../../../util/constants'

export const BusinessDescriptionModal = ({
	step,
	setStep,
	formData,
	setFormData,
	onUpdateProfile,
	saving = false,
}) => {
    const accountType = useSelector((s) => s.auth.accountType)
    
	return (
		<>
			<Grid size={{ xs: 12, sm: 12 }} className={Style.formContainer}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'space-between',
						minHeight: '80%',
						height: '100%',
						gap: '30px',
					}}
					className={Style.titleContainer}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<Typography
							variant="h3"
							gutterBottom
							className={Style.title}
						>
							Business Description
						</Typography>
						<Typography
							variant="h6"
							className={Style.modalSemiTitle}
						>
							Add a description of your business
						</Typography>
					</Box>
					<Box sx={{ width: '100%' }}>
						<FormLabel
							sx={{
								fontSize: '16px',
								fontWeight: '400',
								color: '#313131',
								textAlign: 'left',
								width: '100%',
								marginBottom: '5px',
								display: 'block',
							}}
						>
							Description
						</FormLabel>
						<TextArea
							placeholder="Write your business description"
							value={formData.businessDescription}
							onChange={(e) =>
								setFormData({
									...formData,
									businessDescription: e.target.value,
								})
							}
							sx={{
								minHeight:"200px !important"
							}}
						/>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							gap: '10px',
							width: '100%',
							'@media (max-width: 499px)': {
								flexWrap: 'wrap',
								justifyContent: 'center',
								width: '100%',

							},
						}}
					>
						<Box
							className={Style.buttonContainer}
							sx={{
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<Box
								sx={{
									display: 'flex',
									'@media (max-width: 499px)': {
										display: 'none',
									},
								}}
							>
								<Stepper
									totalSteps={BUSINESS_PROFILE_TOTAL_STEPS}
									subSteps={1}
									activeStep={step}
								/>
							</Box>
							<Box
								sx={{
									display: 'flex',
									justifyContent: 'flex-end',
									gap: '16px',
									'@media (max-width: 499px)': {
										justifyContent: 'space-between',
										width: '100%',
									},
								}}
							>
								<ButtonCustom
									onClick={
                                        () => {
                                            if(accountType === 'kazoo-planner'){
                                                return setStep((step) => step - 2)
                                            }
                                            setStep((step) => step - 1)
                                        }
                                    }
									className="backButton"
								>
									Previous
								</ButtonCustom>
								<ButtonCustom
									disabled={saving}
									onClick={() => {
										if (formData.businessDescription?.trim()) {
											onUpdateProfile(() =>setStep((step) => step + 1))
											return
										}
										toastHelper('Please add a business description','error')
									}}
								>
									{saving ? 'Saving…' : 'Next'}
								</ButtonCustom>
							</Box>
						</Box>
						<Box
							sx={{
								justifyContent: 'center',
								alignItems: 'center',
								display: 'none',
								'@media (max-width: 499px)': {
									display: 'flex',
								},
							}}
						>
							<Stepper
								totalSteps={BUSINESS_PROFILE_TOTAL_STEPS}
								subSteps={1}
								activeStep={step}
							/>
						</Box>
					</Box>
				</Box>
			</Grid>
		</>
	)
}
